<template>
  <li class="mb-1">
    <RouterLink :to="linkName">
      <div class="d-flex justify-content-between">
        <span class="ms-3 menu-link">
        <i :class="['fa-solid me-1',iconName]"></i>
        {{ title }}
      </span>
        <span :class="['badge badge-center rounded-pill me-3', isShow]">{{ notiCount }}</span>
      </div>
    </RouterLink>
  </li>
</template>

<script>
export default {
  name: "Sideli",
  props: {
    title: {
      type: String,
      default: "Link Item Name"
    },
    linkName:{
      type: String,
      require: true,
    },
    iconName:{
      type:String,
      default: "fa-home",
    },
    notiCount:{
      type: String,
      default: null
    }
  },
  computed: {
    isShow(){
       return this.notiCount ? "d-block": "d-none";
    }
  },
}
</script>

<style scoped>
.menu-link{
  font-size: .9rem;
}
li{
  list-style: none;
}
li a{
  padding: 10px;
  text-decoration: none;
  color: #ffffff;
  display: block;
  font-size: 1.1em !important;
}
li a:hover {
  color: #7386D5;
  background: #f5f5f5;
}
li a.active{
  color: #ffffff;
  background: #5268c2;
}
.badge{
  background: #a89fe2 !important;
}
</style>